import { Box } from '@mui/material';
import agent from '@root/agent';
import MuiTable from '@root/components/table/table'; //  { DEFAULT_PAGE_SIZE }
import useEnhancedQuery from '@root/query/useEnhancedQuery';
import {
  // useState,
  // useCallback,
  useMemo,
} from 'react';
import { workloadVulSideoverlayColumns } from './workloadVulSideoverlayColumns';
const RuntimeAnalysis = props => {
  const { selectedRow, workLoadId } = props;

  const cveId = selectedRow?.cve_id ?? selectedRow?.vulnerability_id ?? '';

  const { data: riskAnalysisData, isFetching: isFetchingRiskAnalysisData } = useEnhancedQuery(
    // `workLoadId` and the CVE belong in the key: without them the response of the
    // first CVE opened was served for every later one.
    ['get_workloads_vul_runtime_analysis_table_details', selectedRow, workLoadId, cveId],
    () =>
      agent.Kubernetes.get_workloads_vul_runtime_analysis_table_details({
        // scope: selectedEnvironmentTags,
        environment: selectedRow?.account_id,
        cluster_name: selectedRow?.cluster,
        cve_id: cveId,
        workload_id: workLoadId,
      }),
    // Nothing to analyse without a workload and a CVE, and the request errors out
    // when either is missing.
    { enabled: Boolean(workLoadId && cveId) },
  );

  const _tableData = useMemo(() => {
    // `data` is an object keyed by workload; it is absent while the query is
    // disabled or has failed, so read it defensively rather than indexing it.
    const data = riskAnalysisData?.data;
    if (isFetchingRiskAnalysisData || !data) return [];

    const [key] = Object.keys(data);
    if (!key || !Array.isArray(data[key])) return [];

    return data[key].map((item, idx) => ({ ...item, id: idx + 1 }));
  }, [isFetchingRiskAnalysisData, riskAnalysisData?.data]);

  return (
    <div style={{ position: 'relative', display: 'flex', flexDirection: 'row' }}>
      <Box display="flex" flexDirection="row" flex={1}>
        <MuiTable
          columns={workloadVulSideoverlayColumns(selectedRow)}
          rows={_tableData}
          noDataMessage={'No Runtime Data present!'}
          paginationMode="server"
          LoaderState={isFetchingRiskAnalysisData}
          sortingMode="server"
          total_size={_tableData?.length}
          // page={currentPage}
          // onPageChange={handlePageChange}
          // pageSize={pageSize}
          hideFooter={true}
          // onPageSizeChange={handlePageSizeChange}
          rowHeight={49.9}
          tableHeight={'637px'}
        />
      </Box>
    </div>
  );
};

export default RuntimeAnalysis;
